import { LabelBadge, OptionIcons, OptionWithIcons } from 'components/shared/form/OptionLabel';
import { colors } from 'styles/theme/colors';
import AwardIcon from 'svg/AwardIcon';

// Announced as "Preferred provider" where it marks an option. Decorative next to text that already says so.
export function PreferredProviderIcon({ size = 14, decorative = false }: { size?: number; decorative?: boolean }) {
  const a11yProps = decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Preferred provider' };

  return <AwardIcon width={size} height={size} color={colors.yellow100} {...a11yProps} />;
}

// The field label's legend, shown when the location has preferred providers of the picked type.
export function PreferredProviderBadge() {
  return (
    <LabelBadge>
      <PreferredProviderIcon size={12} decorative />
      <span>Preferred Provider</span>
    </LabelBadge>
  );
}

type PreferredOptionLabelProps = {
  label: React.ReactNode;
  preferred: boolean;
  // Any other icons, after the ribbon.
  children?: React.ReactNode;
};

// A provider option's label with the ribbon when it's preferred, for the menu and the selected value alike.
export function PreferredOptionLabel({ label, preferred, children }: PreferredOptionLabelProps) {
  if (!preferred && !children) return <>{label}</>;

  return (
    <OptionWithIcons>
      {label}
      <OptionIcons>
        {preferred && <PreferredProviderIcon />}
        {children}
      </OptionIcons>
    </OptionWithIcons>
  );
}
